import { useTranslation } from 'react-i18next';
import React from 'react';
import { MintWeb3IdBtn } from '@/components';

import style from './index.module.scss';
import clsx from 'clsx';

export const MintIdBanner = ({
  isSybil,
  className,
  inComment,
  onClickMint,
}: {
  isSybil: boolean;
  className?: string;
  inComment?: boolean;
  onClickMint?: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(style.mintId, className)}>
      {isSybil ? (
        <span>{t('MintIdBanner.1kclh83')}</span>
      ) : (
        <>
          <div>
            <span>{t('MintIdBanner.tip1')}</span>
            {inComment ? <br /> : ' '}
            <span>{t('MintIdBanner.tip2')}</span>
          </div>
          <MintWeb3IdBtn
            className={clsx(style.mintIdBtn, inComment && style.min)}
            onClick={onClickMint}
          />
        </>
      )}
    </div>
  );
};
